import React from 'react';
import WidthContainer from '../../../WidthContainer';
import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import { BodyLarge } from '../../../Texts';
import Button from '../../../Button';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  min-height: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    padding: 40px 0px;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  max-width: 700px;

  img {
    width: 100%;
    height: auto;
  }

  @media ${PHONE_MEDIA_QUERY} {
    max-width: 100%;
    margin-top: 50px;
    padding: 0 20px;
  }
`;

const Title = styled.h1`
  font-family: Inter;
  font-size: 72px;
  color: ${({ theme }) => theme.text.title};
  font-weight: bold;
  line-height: normal;
`;

const PartnersHero = () => {
  return (
    <WidthContainer>
      <Container>
        <InnerContainer style={{ alignItems: 'flex-start', gap: 30 }}>
          <Title>
            DEKS
            <br />
            TOKEN
            <br />
            PARTNER
            <br />
            PROGRAM
          </Title>
          <BodyLarge>
            Launch your token to mainstream users in 24 hours
          </BodyLarge>
          <Button
            onClick={() => {
              window.open(
                'https://calendly.com/kevin-deks/deks-platform-intro',
                '_blank',
              );
            }}
          >
            JOIN NOW
          </Button>
        </InnerContainer>
        <InnerContainer>
          <ImageContainer>
            <img src='/partner.webp' alt='Partner with giftcards' />
          </ImageContainer>
        </InnerContainer>
      </Container>
    </WidthContainer>
  );
};

export default PartnersHero;
